import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

type DiscardModalProps = {
	open: boolean;
	onClose?: (accept: boolean) => void;
};

export const DiscardModal: React.FC<DiscardModalProps> = ({ open, onClose }) => {
	const [openModal, setOpenModal] = useState<boolean>(false);

	const { t } = useTranslation();

	useEffect(() => {
		setOpenModal(open);
	}, [open]);

	function onCloseModal(accept: boolean) {
		if (onClose) {
			onClose(accept);
		}
		setOpenModal(false);
	}

	return (
		<Modal
			title={t('common.discardModal.title')}
			open={openModal}
			centered
			onOk={() => onCloseModal(true)}
			okText={t('common.delete')}
			onCancel={() => onCloseModal(false)}
			cancelText={t('common.cancel')}
		>
			<div>{t('common.discardModal.description')}</div>
		</Modal>
	);
};
